import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard } from "@/components/auth-guard";
import { getAuthToken } from "@/lib/auth/storage";
import ChatPage from "@/pages/ChatPage";
import LoginPage from "@/pages/LoginPage";

function RootRedirect() {
  return <Navigate to={getAuthToken() ? "/chat" : "/login"} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<AuthGuard />}>
          <Route path="/" element={<ChatPage />} />
          <Route path="/chat" element={<ChatPage />} />
        </Route>
        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}
